import Handle from '~/prix/react/components/handle'
import styled from 'styled-components'
import { PulseLoader } from 'react-spinners'
import { AppError } from '~/prix'
import { OverlayLoading } from '~/components/mapContent/styles/overlayLoading'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .legends-desktop {
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      display: none;
    }
  }
`

interface WrapperScreenProps {
  isLoadingScreen: boolean
  error: Error | AppError | null
  isLoadingFeature: boolean
  children: React.ReactNode
}

export const BaseWrapperScreen = ({
  isLoadingFeature,
  isLoadingScreen,
  error,
  children,
}: WrapperScreenProps) => {
  return (
    <Handle isLoading={isLoadingScreen} error={error}>
      <Wrapper>
        {children}
        {isLoadingFeature ? (
          <OverlayLoading>
            <div className='center'>
              <PulseLoader color='#fff' />
              <div className='message'>Carregando...</div>
            </div>
          </OverlayLoading>
        ) : null}
      </Wrapper>
    </Handle>
  )
}
